import { Component, ReactNode } from 'react';
import PropTypes from 'prop-types';

export interface ErrorBoundaryProps {
  onError: (error: Error, info: React.ErrorInfo) => void;
  renderError: () => ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, State> {
  static propTypes = {
    children: PropTypes.node,
    onError: PropTypes.func,
    renderError: PropTypes.func,
  };

  static defaultProps = {
    // eslint-disable-next-line
    onError: (...args: any[]) => console.warn(...args),
    renderError: () => null,
  };

  state: State = { hasError: false };

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    const { onError } = this.props;

    this.setState({ hasError: true });
    onError(error, info);
  }

  render() {
    const { hasError } = this.state;
    const { children, renderError } = this.props;

    if (hasError) return renderError();

    return children;
  }
}

export default ErrorBoundary;
